import { and, count, eq, type PowerSyncDrizzleDB, product } from "@stockpilot/powersync";
import { liveProductFilters } from "./filters";

/**
 * Counts LIVE products of an organization in the local SQLite. Feeds
 * `checkUnsyncedActor` («keep local data?» prompt when migrating from
 * guest to real account): previously ran RAW `count() from(product)` in
 * `auth/controllers.ts`, counting trash items as well (scattered invariant
 * bug — a deleted product triggered the "you have local data" prompt even when
 * the visible catalog was empty). Via the live layer it only counts live items,
 * consistent with other views. (The guest→real merge runs anyway via
 * `sweepVisitorData`, so no row is lost; this counter only decides whether
 * to SHOW the prompt.)
 */
export function getLiveProductCountForOrgQuery(db: PowerSyncDrizzleDB, orgId: string) {
  return db
    .select({ total: count() })
    .from(product)
    .where(and(eq(product.organization_id, orgId), ...liveProductFilters()));
}
